import { cn } from '@nextui-org/react'

import { OrderStatusEnum } from '../libs/type'

interface OrderStatusProps {
  status: OrderStatusEnum
}

export function OrderStatus({ status }: Readonly<OrderStatusProps>) {
  return (
    <div
      className={cn('px-4 py-1 text-sm uppercase', {
        'bg-blue-400 text-white': status === OrderStatusEnum.PROCESSING,
        'bg-gray-400': status === OrderStatusEnum.DRAFT,
        'bg-green-400 text-white': status === OrderStatusEnum.COMPLETED,
        'bg-purple-400': status === OrderStatusEnum.REFUNDED,
        'bg-red-400 text-white':
          status === OrderStatusEnum.FAILED ||
          status === OrderStatusEnum.CANCELLED,
        'bg-yellow-500 text-white':
          status === OrderStatusEnum.PENDING ||
          status === OrderStatusEnum.PENDING_PAYMENT ||
          status === OrderStatusEnum.ON_HOLD ||
          status === OrderStatusEnum.CONFIRMS_PAYMENT ||
          status === OrderStatusEnum.PACKING,
      })}
    >
      {status === OrderStatusEnum.ON_HOLD && 'Confirm Order'}
      {status === OrderStatusEnum.PENDING && 'Pending'}
      {status === OrderStatusEnum.PENDING_PAYMENT && 'Pending Payment'}
      {status === OrderStatusEnum.PROCESSING && 'Processing'}
      {status === OrderStatusEnum.COMPLETED && 'Completed'}
      {status === OrderStatusEnum.CANCELLED && 'Cancelled'}
      {status === OrderStatusEnum.FAILED && 'Failed'}
      {status === OrderStatusEnum.REFUNDED && 'Refunded'}
      {status === OrderStatusEnum.DRAFT && 'Draft'}
      {status === OrderStatusEnum.PACKING && 'Packing'}
      {status === OrderStatusEnum.CONFIRMS_PAYMENT && 'Checking Payment'}
    </div>
  )
}

export default OrderStatus
